import { JSX } from 'preact';
import { useChorusProgress } from './_shared';

interface ChorusMarkProps {
  size?: number;
  animate?: boolean;
}

export function ChorusMark({ size = 28, animate = false }: ChorusMarkProps): JSX.Element {
  const t = useChorusProgress(animate, 900);

  const spread = 1 - t;
  const cx1 = 12 - spread * 6;
  const cx2 = 20 + spread * 6;
  const cx3 = 16;
  const cy3 = 20 + spread * 4;

  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <circle cx={cx1} cy={12} r={8} fill="var(--st-accent-warm)" opacity="0.85" />
      <circle cx={cx2} cy={12} r={8} fill="var(--st-accent-calm)" opacity="0.85" style={{ mixBlendMode: 'multiply' }} />
      <circle cx={cx3} cy={cy3} r={8} fill="var(--st-accent-highlight)" opacity="0.85" style={{ mixBlendMode: 'multiply' }} />
    </svg>
  );
}
